<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Maklumat Peranan"
  >
    <z-page 
      :title="role.name" 
      icon="fal fa-check-circle"
    >
      <template #buttons>
        <w-button icon="fal fa-circle" text md class="ml0" color="success"></w-button>
      </template>

      <w-card bg-color="z-pale-blue" class="mt4">


        <w-flex class="mt3 mb4">
          <div class="xs4">
              <h5 class="fw-semibold m0">
                  Nama :
              </h5>
              <div class="fw-normal my1 fs-1"> {{ role.name }} </div>
          </div>
          <div class="xs4">
            <h5 class="fw-semibold m0">
                Tarikh Cipta :
            </h5>
            <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(role.created_at) }} </div>
          </div>
            <div class="xs4">
                <h5 class="fw-semibold m0">
                    Tarikh Ubah Akhir :
                </h5>
                <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(role.updated_at) }} </div>
            </div>
        </w-flex>

            <permission
              title="Senarai Kebenaran"
              :user="role"
              :items="permissions"
              which="permission"
              parent="administration.role.update"
              v-model:selected="role.permissions_id"
              >
            </permission> 
            <div class="mt2 text-left">
          <w-button bg-color="grey-light5--bg" @click="tutup()">TUTUP</w-button>&nbsp;
        </div>               
          
      </w-card>

        
    </z-page>
  </zen-one>
</template>

<script>
import Permission from '@/Pages/Admin/User/Subs/Permission.vue'

export default {
  components: {
    Permission
  },
  props: {
    role: [Array, Object],
    roles: [Array, Object],
    permissions: [Array, Object],
  },
  data() {
    return {
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Peranan', route: '/administration/role' },
        { label: this.role.name , route: '/administration/role' }
      ],
      tabs: [
        { title: 'Kebenaran', content: '' },
        { title: 'Pengguna', content: 'Pipizola' },
      ],
    }
  },
  methods: {
   tutup(){
     this.$inertia.visit(window.route('administration.role.index'));
   },
  
  },
  watch: {

  },
  mounted() {

    
      
  },
}
</script>